import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  appBox: {
    height: "var(--vh)",
    overflow: "hidden",
  },
  onboarding: {
    overflowY: "auto",
  },
  appContainer: {
    padding: 0,
    overflow: "hidden",

    [theme.breakpoints.up("lg")]: {
      paddingLeft: "40px",
      paddingRight: "40px",
    },

    height: `calc(var(--vh) - ${theme.mixins.toolbar.minHeight}px)`,
    marginTop: `${theme.mixins.toolbar.minHeight}px`,
    [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
      height: `calc(var(--vh) - ${
        theme.mixins.toolbar[theme.breakpoints.up("xs")][
          "@media (orientation: landscape)"
        ].minHeight
      }px)`,
      marginTop: `${
        theme.mixins.toolbar[theme.breakpoints.up("xs")][
          "@media (orientation: landscape)"
        ].minHeight
      }px`,
    },
    [theme.breakpoints.up("sm")]: {
      height: `calc(var(--vh) - ${theme.mixins.toolbar.minHeight}px)`,
      marginTop: `${theme.mixins.toolbar.minHeight}px`,
    },

    [theme.breakpoints.up("lg")]: {
      height: `calc(var(--vh) - ${theme.mixins.toolbar.minHeight}px)`,
      marginTop: `${theme.mixins.toolbar.minHeight}px`,
    },
  },
  mainContent: {
    overflowY: "auto",
    padding: "16px",

    // Extra bottom padding to prevent the Twilio chat button from covering anything
    "&$extraPadding": {
      paddingBottom: "60px !important",
    },
  },
  extraPadding: {},
  noContentPadding: {
    padding: 0,
  },
  rightRail: {
    paddingRight: "0 !important",
  },
  rightRailBox: {
    height: `calc(var(--vh) - ${theme.mixins.toolbar.minHeight}px)`,
    overflowY: "scroll",
    position: "sticky",
    top: 0,
    borderLeft: "1px solid rgba(0,0,0,0.12)",
    "&.MuiGrid-item": {
      padding: 0,
    },
  },
  rightDrawer: {
    "& .MuiDrawer-paper": {
      width: "282px",
    },
  },
}));

export default useStyles;
